function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var M = function () {
    function n() {}
    return n.prototype.getApplicationContext = function () {
      return {
        versionName: this.versionName,
        language: $(),
        platform: "Web",
        os: void 0,
        deviceModel: void 0
      };
    }, n;
  }(),
  $ = function $() {
    return (typeof navigator === "undefined" ? "undefined" : _typeof(navigator)) < "u" && (navigator.languages && navigator.languages[0] || navigator.language) || "";
  },
  R = function () {
    function n() {
      this.queue = [];
    }
    return n.prototype.logEvent = function (e) {
      this.receiver ? this.receiver(e) : this.queue.length < 512 && this.queue.push(e);
    }, n.prototype.setEventReceiver = function (e) {
      this.receiver = e, this.queue.length > 0 && (this.queue.forEach(function (t) {
        e(t);
      }), this.queue = []);
    }, n;
  }(),
  _D = function D() {
    return _D = Object.assign || function (e) {
      for (var t, r = 1, i = arguments.length; r < i; r++) {
        t = arguments[r];
        for (var u in t) Object.prototype.hasOwnProperty.call(t, u) && (e[u] = t[u]);
      }
      return e;
    }, _D.apply(this, arguments);
  };
function A(n) {
  var e = typeof Symbol == "function" && Symbol.iterator,
    t = e && n[e],
    r = 0;
  if (t) return t.call(n);
  if (n && typeof n.length == "number") return {
    next: function next() {
      return n && r >= n.length && (n = void 0), {
        value: n && n[r++],
        done: !n
      };
    }
  };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function T(n, e) {
  var t = typeof Symbol == "function" && n[Symbol.iterator];
  if (!t) return n;
  var r = t.call(n),
    i,
    u = [],
    y;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = r.next()).done;) u.push(i.value);
  } catch (d) {
    y = {
      error: d
    };
  } finally {
    try {
      i && !i.done && (t = r.return) && t.call(r);
    } finally {
      if (y) throw y.error;
    }
  }
  return u;
}
var U = function U(n, e) {
    var t,
      r,
      i = ["string", "number", "boolean", "undefined"],
      u = _typeof(n),
      y = _typeof(e);
    if (u !== y) return !1;
    try {
      for (var d = A(i), m = d.next(); !m.done; m = d.next()) {
        var I = m.value;
        if (I === u) return n === e;
      }
    } catch (a) {
      t = {
        error: a
      };
    } finally {
      try {
        m && !m.done && (r = d.return) && r.call(d);
      } finally {
        if (t) throw t.error;
      }
    }
    if (n == null && e == null) return !0;
    if (n == null || e == null || n.length !== e.length) return !1;
    var _ = Array.isArray(n),
      w = Array.isArray(e);
    if (_ !== w) return !1;
    if (_ && w) {
      for (var p = 0; p < n.length; p++) if (!U(n[p], e[p])) return !1;
    } else {
      var c = Object.keys(n).sort(),
        o = Object.keys(e).sort();
      if (!U(c, o)) return !1;
      var s = !0;
      return Object.keys(n).forEach(function (a) {
        U(n[a], e[a]) || (s = !1);
      }), s;
    }
    return !0;
  },
  G = "$set",
  F = "$unset",
  Z = "$clearAll";
Object.entries || (Object.entries = function (n) {
  for (var e = Object.keys(n), t = e.length, r = new Array(t); t--;) r[t] = [e[t], n[e[t]]];
  return r;
});
var W = function () {
    function n() {
      this.identity = {
        userProperties: {}
      }, this.listeners = new Set();
    }
    return n.prototype.editIdentity = function () {
      var e = this,
        t = _D({}, this.identity.userProperties),
        r = _D(_D({}, this.identity), {
          userProperties: t
        });
      return {
        setUserId: function setUserId(i) {
          return r.userId = i, this;
        },
        setDeviceId: function setDeviceId(i) {
          return r.deviceId = i, this;
        },
        setUserProperties: function setUserProperties(i) {
          return r.userProperties = i, this;
        },
        setOptOut: function setOptOut(i) {
          return r.optOut = i, this;
        },
        updateUserProperties: function updateUserProperties(i) {
          var u,
            y,
            d,
            m,
            I,
            _,
            w = r.userProperties || {};
          try {
            for (var p = A(Object.entries(i)), c = p.next(); !c.done; c = p.next()) {
              var o = T(c.value, 2),
                s = o[0],
                a = o[1];
              switch (s) {
                case G:
                  try {
                    for (var g = (d = void 0, A(Object.entries(a))), f = g.next(); !f.done; f = g.next()) {
                      var P = T(f.value, 2),
                        S = P[0],
                        v = P[1];
                      w[S] = v;
                    }
                  } catch (E) {
                    d = {
                      error: E
                    };
                  } finally {
                    try {
                      f && !f.done && (m = g.return) && m.call(g);
                    } finally {
                      if (d) throw d.error;
                    }
                  }
                  break;
                case F:
                  try {
                    for (var l = (I = void 0, A(Object.keys(a))), h = l.next(); !h.done; h = l.next()) {
                      var S = h.value;
                      delete w[S];
                    }
                  } catch (E) {
                    I = {
                      error: E
                    };
                  } finally {
                    try {
                      h && !h.done && (_ = l.return) && _.call(l);
                    } finally {
                      if (I) throw I.error;
                    }
                  }
                  break;
                case Z:
                  w = {};
                  break;
              }
            }
          } catch (E) {
            u = {
              error: E
            };
          } finally {
            try {
              c && !c.done && (y = p.return) && y.call(p);
            } finally {
              if (u) throw u.error;
            }
          }
          return r.userProperties = w, this;
        },
        commit: function commit() {
          return e.setIdentity(r), this;
        }
      };
    }, n.prototype.getIdentity = function () {
      return _D({}, this.identity);
    }, n.prototype.setIdentity = function (e) {
      var t = _D({}, this.identity);
      this.identity = _D({}, e), U(t, this.identity) || this.listeners.forEach(function (r) {
        r(e);
      });
    }, n.prototype.addIdentityListener = function (e) {
      this.listeners.add(e);
    }, n.prototype.removeIdentityListener = function (e) {
      this.listeners.delete(e);
    }, n;
  }(),
  b = (typeof globalThis === "undefined" ? "undefined" : _typeof(globalThis)) < "u" ? globalThis : (typeof window === "undefined" ? "undefined" : _typeof(window)) < "u" ? window : self,
  L = function () {
    function n() {
      this.identityStore = new W(), this.eventBridge = new R(), this.applicationContextProvider = new M();
    }
    return n.getInstance = function (e) {
      return b.analyticsConnectorInstances || (b.analyticsConnectorInstances = {}), b.analyticsConnectorInstances[e] || (b.analyticsConnectorInstances[e] = new n()), b.analyticsConnectorInstances[e];
    }, n;
  }();
var x = ["boot"];
var z = "$default_instance";
function k(n) {
  var i, u, y, d, m, I, _, w, p;
  var e = (typeof window === "undefined" ? "undefined" : _typeof(window)) < "u" ? window.engagement : void 0,
    t = {
      _q: (i = e == null ? void 0 : e._q) != null ? i : [],
      _configuration: {
        apiKey: (y = (u = e == null ? void 0 : e._configuration) == null ? void 0 : u.apiKey) != null ? y : "",
        serverUrl: (d = e == null ? void 0 : e._configuration) == null ? void 0 : d.serverUrl,
        chatUrl: (m = e == null ? void 0 : e._configuration) == null ? void 0 : m.chatUrl,
        mediaUrl: (I = e == null ? void 0 : e._configuration) == null ? void 0 : I.mediaUrl,
        serverZone: (w = (_ = e == null ? void 0 : e._configuration) == null ? void 0 : _.serverZone) != null ? w : "US",
        options: _objectSpread({}, (p = e == null ? void 0 : e._configuration) == null ? void 0 : p.options)
      },
      _sentry: void 0,
      init: function init(c, o) {
        var P, S, v;
        if (t._configuration.apiKey) {
          console.log("Engagement SDK has already been initialized. Ignoring additional init call.");
          return;
        }
        t._configuration = _objectSpread(_objectSpread(_objectSpread({}, t._configuration), o), {}, {
          apiKey: c,
          options: _objectSpread(_objectSpread({
            splitting: !0
          }, t._configuration.options), o == null ? void 0 : o.options)
        }), (S = (P = t._configuration) == null ? void 0 : P.options) != null && S.logger && t._configuration.options.logger.enable((v = t._configuration.options.logLevel) != null ? v : 2);
        var s;
        if (o != null && o.cdnUrl) t._configuration.options.splitting ? s = "".concat(o.cdnUrl, "/engagement-browser/prod/split/index.js") : s = o.cdnUrl + "/engagement-browser/prod/index.min.js.gz";else {
          var l = t._configuration.serverZone === "EU" ? "https://cdn.eu.amplitude.com" : "https://cdn.amplitude.com";
          t._configuration.options.splitting ? s = "".concat(l, "/engagement-browser/prod/split/index.js") : s = "".concat(l, "/engagement-browser/prod/index.min.js.gz");
        }
        var a = null,
          g = function g() {
            if (a && (clearTimeout(a), a = null), t._q && t._q.length > 0) for (console.warn("Engagement SDK failed to load within ".concat(f, "ms. Resolving pending calls gracefully.")); t._q.length > 0;) {
              var _l = t._q.shift();
              if (!_l) continue;
              var h = _l[0];
              if (x.includes(h) && _l[1] instanceof Function && _l[2] instanceof Function) {
                var E = _l[1];
                console.warn("Engagement SDK method '".concat(h, "' resolved as no-op due to script loading failure")), E(void 0);
              }
            }
          };
        n(s, t._configuration.options.splitting ? "module" : void 0, o == null ? void 0 : o.nonce, g);
        var f = 1e4;
        a = setTimeout(function () {
          g();
        }, f);
      },
      plugin: function plugin(c) {
        var o = t.init;
        return {
          name: "@amplitude/engagement-browser",
          type: "enrichment",
          setup: function setup(s, a) {
            return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
              var S, g, f, P;
              return _regeneratorRuntime().wrap(function _callee$(_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    g = (S = s.instanceName) != null ? S : z, f = L.getInstance(g).identityStore;
                    o(s.apiKey, _objectSpread(_objectSpread({
                      serverZone: s.serverZone
                    }, c), {}, {
                      options: _objectSpread({
                        logLevel: s.logLevel,
                        logger: s.loggerProvider
                      }, c == null ? void 0 : c.options)
                    }));
                    P = [{
                      track: function track(v) {
                        a.track(v);
                      }
                    }];
                    _context.next = 5;
                    return window.engagement.boot({
                      user: function user() {
                        var v = f.getIdentity();
                        return {
                          user_id: a.getUserId(),
                          device_id: a.getDeviceId(),
                          user_properties: v.userProperties,
                          getSessionId: a.getSessionId
                        };
                      },
                      integrations: P
                    });
                  case 5:
                    f.addIdentityListener(function (v) {
                      var l, h, E, C;
                      if (!((l = window.engagement) != null && l._.user) || !((h = window.engagement) != null && h._analytics.hasBooted)) {
                        console.warn("Engagement SDK not booted. Ignoring identity change.");
                        return;
                      }
                      ((C = (E = window.engagement) == null ? void 0 : E._.user) == null ? void 0 : C.user_id) !== v.userId ? (window.engagement.shutdown(), window.engagement.boot({
                        user: function user() {
                          var B = f.getIdentity();
                          return {
                            user_id: a.getUserId(),
                            device_id: a.getDeviceId(),
                            user_properties: B.userProperties,
                            getSessionId: a.getSessionId
                          };
                        },
                        integrations: P
                      })) : window.engagement._setUserProperties(v.userProperties);
                    });
                  case 6:
                  case "end":
                    return _context.stop();
                }
              }, _callee);
            }))();
          },
          execute: function execute(s) {
            return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
              return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                while (1) switch (_context2.prev = _context2.next) {
                  case 0:
                    return _context2.abrupt("return", (window.engagement.forwardEvent(s), s));
                  case 1:
                  case "end":
                    return _context2.stop();
                }
              }, _callee2);
            }))();
          }
        };
      }
    },
    r = t;
  return new Proxy(t, {
    get: function get(c, o) {
      if (o in r) return r[o];
      if (o !== "then") return o === "gs" || o === "rc" ? new Proxy({}, {
        get: function get(s, a) {
          return function () {
            var g = Array.from(arguments),
              f = "".concat(o, ".").concat(a);
            g.unshift(f), t._q.push(g);
          };
        }
      }) : x.includes(o) ? function () {
        var s = Array.prototype.slice.call(arguments);
        return new Promise(function (a, g) {
          s.unshift(o, a, g), t._q.push(s);
        });
      } : function () {
        var s = Array.prototype.slice.call(arguments);
        s.unshift(o), t._q.push(s);
      };
    }
  });
}
var N = function (i) {
    return i.Local = "https://local.amplitude.com:3010/", i.Staging = "https://apps.stag2.amplitude.com/", i.Production = "https://app.amplitude.com/", i.ProductionEU = "https://app.eu.amplitude.com/", i;
  }(N || {}),
  O = function O(n) {
    if ((typeof window === "undefined" ? "undefined" : _typeof(window)) < "u" && window.opener) for (var _i = 0, _Object$values = Object.values(N); _i < _Object$values.length; _i++) {
      var e = _Object$values[_i];
      window.opener.postMessage({
        message: n
      }, e);
    }
  };
function H(n, e, t, r) {
  var _iterator = _createForOfIteratorHelper(n),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var i = _step.value;
      var u = document.createElement("script");
      u.src = i, u.id = "engagement-sdk-bundle", t && u.setAttribute("nonce", t), e && u.setAttribute("type", e), r && (u.onerror = r), document.getElementsByTagName("head")[0].appendChild(u);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
}
var q = function q() {
  return O("ENGAGEMENT_SNIPPET"), k(function (n, e, t, r) {
    return H([n || "https://cdn.amplitude.com/engagement-browser/prod/index.min.js.gz"], e, t, r);
  });
};
var K = q(),
  ie = function ie(n, e) {
    (typeof window === "undefined" ? "undefined" : _typeof(window)) < "u" && !window.engagement && (window.engagement = K), K.init(n, e);
  },
  se = function se(n) {
    return (typeof window === "undefined" ? "undefined" : _typeof(window)) < "u" && !window.engagement && (window.engagement = K), K.plugin(n);
  };
export { ie as init, se as plugin };